import React from "react";
import { useSession } from "../../../SessionContext";
import { ScreenProps } from "../../SequenceController";

export const PretestScreen1 = (props: ScreenProps) => {
    const { userId } = useSession();

    const pretestUrl = userId
        ? `https://survey.ph-karlsruhe.de/BeeT1/?s=${encodeURIComponent(userId)}`
        : undefined;

    return (
        <div className="experiment-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
            <div
                className="pretest-card"
                style={{
                    maxWidth: 460,
                    width: "100%",
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 2px 16px rgba(0,0,0,0.09)",
                    padding: "32px 28px 28px 28px",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                <section aria-labelledby="intro-heading" style={{ width: "100%" }}>
                    <h1 id="intro-heading" style={{ marginBottom: 16 }}>Willkommen zu unserer Studie</h1>
                    <p>
                        Liebe Schülerinnen und Schüler,
                    </p>
                    <p>
                        schön, dass ihr heute dabei seid und an unserer Studie teilnehmt!
                        Zunächst benötigen wir einige allgemeine Informationen über dich. Danach wollen wir wir herausfinden, was ihr schon über wirtschaftliche Tehmen wisst und denkt.
                    </p>
                    <p>
                        Keine Sorge: Es geht nicht um Noten, sondern nur darum, wie viel Vorwissen ihr schon mitbringt.
                    </p>
                </section>

                <div className="navigation-hint" style={{ width: "100%", marginTop: 32, textAlign: "center" }}>
                    <p style={{ marginBottom: 16 }}>
                        Bitte klickt auf <strong>„Weiter“</strong>, um zum Pretest zu gelangen.
                    </p>
                    {pretestUrl ? (
                        <a
                            href={pretestUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                marginTop: 12,
                                minWidth: 140,
                                fontSize: 18,
                                padding: "12px 32px",
                                background: "#2563eb",
                                color: "#fff",
                                border: "none",
                                borderRadius: 8,
                                textDecoration: "none",
                                fontWeight: 600,
                                boxShadow: "0 2px 8px rgba(37,99,235,0.12)",
                                display: "inline-block",
                                cursor: "pointer",
                                transition: "background 0.15s"
                            }}
                            onMouseOver={e => (e.currentTarget.style.background = "#1d4ed8")}
                            onMouseOut={e => (e.currentTarget.style.background = "#2563eb")}
                        >
                            Weiter
                        </a>
                    ) : (
                        <button
                            disabled
                            style={{
                                marginTop: 12,
                                minWidth: 140,
                                fontSize: 18,
                                padding: "12px 32px",
                                background: "#94a3b8",
                                color: "#fff",
                                border: "none",
                                borderRadius: 8,
                                fontWeight: 600,
                                opacity: 0.7,
                                cursor: "not-allowed"
                            }}
                        >
                            Weiter
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};